// removed by extract-text-webpack-plugin
module.exports = {"fade":"pvjk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pagescreen/fade/style.css
// module id = 393
// module chunks = 9